import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[closeOnOutSide]',
  standalone: true,
})
export class CloseOnOutsideDirective {
  show = false;
  @Output() clickedOutside = new EventEmitter<void>();
  @Input('closeOnOutSide') enableDirective!: boolean;

  @HostListener('document:click', ['$event'])
  documentClicked({ target }: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(target) && this.enableDirective !== false) {
      console.warn('this.documentClicked', this.enableDirective, this.elementRef.nativeElement);
      this.show = false;
      this.clickedOutside.emit();
    } else {
      // console.log('click inside here');
    }
  }

  @HostListener('window:keydown.Escape')
  escapedClicked(): void {
    if (this.enableDirective !== false) {
      console.log('this.escapedClicked', this.enableDirective);
      this.show = false;
      this.clickedOutside.emit();
    }
  }
  constructor(private elementRef: ElementRef) {
    // console.log('click outside here');
  }
}
